module.exports = __webpack_public_path__ + "img/promo_pc@2x.456085c3.png";